var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEngine = function SvgEngine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M4 9.27h1.69l1.66-1.66h6.77l1.68 1.68h1.7v2.16h1.69V8.73h1.69A9.29 9.29 0 0 1 22 13.14a8.71 8.71 0 0 1-1.16 4.31h-1.65v-2.72H17.5V18H9.62l-2.21-2.22H4ZM7.94 6h5.62m-2.81 0v1.61M4 12.81H1.91V8.75v7.53",
    vectorEffect: "non-scaling-stroke"
  })));
};
export { SvgEngine as ReactComponent };
export default __webpack_public_path__ + "3730a1e77e0c0514d9d9fd436ddffd12.svg";